import { useEffect, useState } from 'react';
import { NAV_LINKS } from '../constants/content';
import { trackDownloadClick } from '../services/analytics';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 12);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 shadow-md backdrop-blur' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex w-full max-w-6xl items-center justify-between px-4 py-4 md:px-8">
        <a href="/" className="font-[Nunito] text-2xl font-extrabold text-[#5B3FA6]">
          <span className="mr-1" role="img" aria-label="toilet">
            🚽
          </span>
          PottyPal
        </a>

        <div className="hidden items-center gap-6 md:flex">
          {NAV_LINKS.map((link) => (
            <a key={link.label} href={link.href} className="text-sm font-semibold text-[#6F655E] hover:text-[#5B3FA6]">
              {link.label}
            </a>
          ))}
          <a
            href="#playstore"
            onClick={() => trackDownloadClick('navbar_desktop')}
            className="rounded-full bg-[#FF7B5B] px-5 py-2 text-sm font-semibold text-white shadow-sm transition hover:-translate-y-0.5 hover:shadow-md"
          >
            Download Free
          </a>
        </div>

        <button
          type="button"
          className="rounded-md p-2 text-[#5B3FA6] md:hidden"
          aria-label="Toggle menu"
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          <span className="block h-0.5 w-6 bg-current" />
          <span className="mt-1.5 block h-0.5 w-6 bg-current" />
          <span className="mt-1.5 block h-0.5 w-6 bg-current" />
        </button>
      </nav>

      <div
        className={`overflow-hidden bg-white transition-all duration-300 md:hidden ${
          menuOpen ? 'max-h-60 border-t border-[#F2EAE1]' : 'max-h-0'
        }`}
      >
        <div className="mx-auto flex max-w-6xl flex-col gap-4 px-4 py-4">
          {NAV_LINKS.map((link) => (
            <a key={link.label} href={link.href} className="text-sm font-semibold text-[#6F655E]">
              {link.label}
            </a>
          ))}
          <a
            href="#playstore"
            onClick={() => trackDownloadClick('navbar_mobile')}
            className="w-fit rounded-full bg-[#FF7B5B] px-5 py-2 text-sm font-semibold text-white"
          >
            Download Free
          </a>
        </div>
      </div>
    </header>
  );
}

